import { modals } from '../modal/init-modals';

export class Feedback {
  constructor() {
    this._feedback = document.querySelectorAll('[data-feedback]');
    this._modals = modals;
    this._language = document.documentElement.lang;

    this._onSubmitForm = this._onSubmitForm.bind(this);

    this._emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

    this._fileSize = 10 * 1024 * 1024;
    this._fileUploadHandler = this._fileUploadHandler.bind(this);
    this._fileDropHandler = this._fileDropHandler.bind(this);
    this._fileDragOverHandler = this._fileDragOverHandler.bind(this);
    this._errors = new Set();

    this._documentClickHandle = this._documentClickHandle.bind(this);

    this._textDictionary = {
      ru: {
        required: 'Заполните все обязательные поля',
        requiredField: 'Это обязательное поле',
        phone: 'Введите пожалуйста корректный номер телефона',
        phoneField: 'Неверный номер телефона',
        email: 'Введите пожалуйста корректный адрес электронной почты',
        emailField: 'Неверный формат почты',
        fileAttach: 'Прикрепить файл',
        fileSupport: 'Этот тип файла не поддерживается',
        fileSize: 'Файл слишком большой',
        fileRemove: 'Удалить',
        size: 'Мб',
      },
      en: {
        required: 'Fill in all required fields',
        requiredField: 'This is a required field',
        phone: 'Please enter the correct phone number',
        phoneField: 'Incorrect phone number',
        email: 'Please enter the correct email address.',
        emailField: 'Invalid email format',
        fileAttach: 'Attach a file',
        fileSupport: 'This file type is not supported',
        fileSize: 'The file is too big',
        fileRemove: 'Remove',
        size: 'Mb',
      },
      az: {
        required: 'Bütün məcburi sahələri doldurun',
        requiredField: 'Bu, məcburi sahədir',
        phone: 'Zəhmət olmasa, düzgün telefon nömrəsi daxil edin',
        phoneField: 'Yanlış telefon nömrəsi',
        email: 'Zəhmət olmasa, düzgün e-poçt ünvanı daxil edin',
        emailField: 'Yanlış e-poçt formatı',
        fileAttach: 'Faylı əlavə et',
        fileSupport: 'Bu fayl növü dəstəklənmir',
        fileSize: 'Fayl çox böyükdür',
        fileRemove: 'Sil',
        size: 'Mb',

      },
      kz: {
        required: 'Міндетті өрістердің барлығын толтырыңыз',
        requiredField: 'Бұл міндетті өріс',
        phone: 'Дұрыс телефон нөмірін енгізіңіз',
        phoneField: 'Дұрыс емес телефон нөмірі',
        email: 'Дұрыс электрондық пошта мекенжайын енгізіңіз',
        emailField: 'Пошта форматы дұрыс емес',
        fileAttach: 'Файлды тіркеу',
        fileSupport: 'Бұл файл түрі қолдау көрсетілмейді',
        fileSize: 'Файл тым үлкен',
        fileRemove: 'Жою',
        size: 'Мб',
      },
      uz: {
        required: 'Барча керакли майдонларни тўлдиринг',
        requiredField: 'Бу талаб қилинадиган майдон',
        phone: 'Илтимос, тўғри telefon рақамини киритинг.',
        phoneField: 'Нотўғри telefon рақами',
        email: 'Илтимос, тўғри електрон почта манзилини киритинг.',
        emailField: 'Хат формати нотўғри',
        fileAttach: 'Файлни бириктиринг',
        fileSupport: 'Ушбу файл тури қўллаб-қувватланмайди.',
        fileSize: 'Файл жуда катта',
        fileRemove: 'Ўчириш',
        size: 'Мб',
      },
      tj: {
        required: 'Ҳама майдонҳои заруриро пур кунед',
        requiredField: 'Ин майдони ҳатмист',
        phone: 'Лутфан рақами телефони дурустро ворид кунед',
        phoneField: 'Рақами телефони нодуруст',
        email: 'Лутфан суроғаи почтаи электронии дурустро ворид кунед',
        emailField: 'Формати нодурусти почта',
        fileAttach: 'Замима кардани файл',
        fileSupport: 'Ин намуди файл дастгирӣ намешавад',
        fileSize: 'Файл хеле калон аст',
        fileRemove: 'Нест кардан',
        size: 'Мб',
      },
    };
  }

  init() {
    if (!this._feedback.length) {
      return;
    }

    this._feedback.forEach((element) => {
      const form = element.querySelector('[data-feedback-form]');
      const file = element.querySelector('[data-file]');

      if (file) {
        const input = file.querySelector('[data-file-input]');
        this._initFile(file, input);
      }

      form.addEventListener('submit', this._onSubmitForm);
    });
  }

  _initFile(parent, input) {
    input.addEventListener('change', this._fileUploadHandler);
    document.addEventListener('click', this._documentClickHandle);
    // parent.addEventListener('drop', this._fileDropHandler);
    // parent.addEventListener('dragover', this._fileDragOverHandler);
  }

  _documentClickHandle(evt) {
    const target = evt.target;

    if (target.closest('[data-file-remove]')) {
      const file = target.closest('[data-file]');
      const info = file.querySelector('[data-file-info]');
      const input = file.querySelector('input');

      input.value = '';
      info.innerHTML = this._textDictionary[this._language]['fileAttach'];
    }
  }

  async _getToken() {
    await new Promise((resolve, reject) => {
      grecaptcha.ready(resolve);
    });

    const token = await grecaptcha.execute('6Lda0FsrAAAAAHbFFODff97wK2WeWaw1YDlkZ6Us', {
      action: 'submit',
    });

    return token;
  }

  async _onSubmitForm(evt) {
    evt.preventDefault();

    const form = evt.target;
    const feedback = form.closest('[data-feedback]');
    const success = feedback.querySelector('[data-feedback-success]');
    const errors = form.querySelector('[data-feedback-errors]');
    feedback.classList.remove('is-error');

    this._validateForm(form);

    if (errors) {
      errors.innerHTML = '';

      if (this._errors.size) {
        this._setErrors(errors);
        feedback.classList.add('is-error');
      }
    }

    if (!this._errors.size) {
      if (feedback.dataset.feedback !== 'subscribe' && feedback.dataset.feedback !== 'modal') {
        const token = await this._getToken();

        const formData = new FormData(form);
        formData.append('action', 'feedback');
        formData.append('token', token);

        try {
          const response = await fetch('/local/templates/xylosuisse/ajax/feedback.php', {
            method: 'POST',
            body: formData,
          });

          const result = await response.json();

          if (result.TYPE === 'success') {
            success.classList.add('is-success');
            setTimeout(() => {
              success.classList.remove('is-success');
            }, 3000);

            form.reset();
          } else if (result.TYPE === 'error') {
            let errorResult = '';

            Array.from(result.RESULT).forEach((error) => {
              errorResult += this._createError(error);
            });

            errors.innerHTML = errorResult;
            feedback.classList.add('is-error');
          }
        } catch (err) {
          console.log('Error: ' + err);
        }
      } else if (feedback.dataset.feedback === 'subscribe') {
        const recaptchaToken = form.querySelector('[data-recaptcha-token]');

        grecaptcha.execute('6Lda0FsrAAAAAHbFFODff97wK2WeWaw1YDlkZ6Us', {
          action: 'submit',
        })
          .then(function (token) {
            recaptchaToken.value = token;
            form.submit();
          });
      }
    }
  }

  _validateForm(form) {
    this._errors.clear();

    const fields = form.querySelectorAll('[data-validate-type]');

    fields.forEach((field) => {
      const type = field.dataset.validateType;

      switch (type) {
        case 'text':
          this._validateTextField(field);
          break;
        case 'phone':
          this._validatePhoneField(field);
          break;
        case 'email':
          this._validateEmailField(field);
          break;
        // case 'file':
        //   this._validateFileField(field);
        //   break;
      }
    });
  }

  _validateTextField(field) {
    const input = field.querySelector('input');
    const error = field.querySelector('[data-validate-error]');

    if (!input.value) {
      field.classList.add('is-error');
      error.textContent = this._textDictionary[this._language]['requiredField'];
      this._errors.add('required');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validatePhoneField(field) {
    const input = field.querySelector('input');
    const error = field.querySelector('[data-validate-error]');

    if (!input.value) {
      field.classList.add('is-error');
      error.textContent = this._textDictionary[this._language]['requiredField'];
      this._errors.add('required');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validateEmailField(field) {
    const input = field.querySelector('input');
    const error = field.querySelector('[data-validate-error]');

    if (field.hasAttribute('data-required')) {
      if (!input.value) {
        field.classList.add('is-error');
        error.textContent = this._textDictionary[this._language]['requiredField'];
        this._errors.add('required');
      } else if (input.value && !this._emailRegex.test(input.value)) {
        field.classList.add('is-error');
        error.textContent = this._textDictionary[this._language]['emailField'];
        this._errors.add('email');
      } else {
        field.classList.remove('is-error');
      }
    } else {
      if (input.value && !this._emailRegex.test(input.value)) {
        field.classList.add('is-error');
        error.textContent = this._textDictionary[this._language]['emailField'];
        this._errors.add('email');
      } else {
        field.classList.remove('is-error');
      }
    }
  }

  _validateFileField(field) {
    const input = field.querySelector('input');

    if (!input.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else {
      field.classList.remove('is-error');
    }
  }

  _fileUploadHandler(evt) {
    evt.preventDefault();

    const target = evt.target;
    const parent = target.closest('[data-file]');
    const files = target.files;

    const info = parent.querySelector('[data-file-info]');
    info.innerHTML = this._textDictionary[this._language]['fileAttach'];

    if (!files.length) {
      return;
    }

    if (files[0].size > this._fileSize) {
      parent.classList.add('is-error');
      info.innerHTML = this._textDictionary[this._language]['fileSupport'];
      target.value = '';
      return;
    }

    if (parent.classList.contains('is-error')) {
      parent.classList.remove('is-error');
    }

    Array.from(files).forEach((file) => {
      info.innerHTML = file.name + ' ' + ((file.size / (1024 * 1024)).toFixed(2)) + ` ${this._textDictionary[this._language]['size']}` + ` <button class="btn-reset contacts-form__remove" type="button" aria-label="${this._textDictionary[this._language]['fileRemove']}" data-file-remove><svg width="14" height="14" aria-hidden="true"><use xlink:href="#icon-close"></use></svg></button>`;
    });
  }

  _fileDropHandler(evt) {
    evt.preventDefault();

    const target = evt.target;
    const parent = target.closest('[data-file]');
    const files = evt.dataTransfer?.files;
    const input = parent.querySelector('[data-file-input]');

    const info = parent.querySelector('[data-file-info]');
    info.innerHTML = '';

    if (!files.length) {
      return;
    }

    if (files[0].size > this._fileSize) {
      parent.classList.add('is-error');
      info.innerHTML = this._textDictionary[this._language]['fileSize'];
      target.value = '';
      return;
    }

    if (parent.classList.contains('is-error')) {
      parent.classList.remove('is-error');
    }

    input.files = files;
    Array.from(files).forEach((file) => {
      info.innerHTML = this._createFileName(file);
    });
  }

  _fileDragOverHandler(evt) {
    evt.preventDefault();
  }

  _createFileName(file) {
    const fileName = file.name + ' ' + ((file.size / (1024 * 1024)).toFixed(2)) + ` ${this._textDictionary[this._language]['size']}`;
    return `
        <span>
          ${fileName}
          <button class="btn-reset contacts-form__remove" type="button" aria-label="${this._textDictionary[this._language]['fileRemove']}" data-file-remove>
            <svg width="10" height="10" aria-hidden="true">
              <use xlink:href="#icon-close"></use>
            </svg>
          </button>
        </span>
    `;
  }

  _setErrors(element) {
    let result = '';

    this._errors.forEach((error, errorAgain, set) => {
      switch (error) {
        case 'required':
          result += this._createError(this._textDictionary[this._language][error]);
          break;
        case 'phone':
          result += this._createError(this._textDictionary[this._language][error]);
          break;
        case 'email':
          result += this._createError(this._textDictionary[this._language][error]);
          break;
      }
    });

    element.innerHTML = result;
  }

  _createError(text) {
    return `
      <p class="errors__message">
        <svg width="24" height="24" aria-hidden="true">
          <use xlink:href="#icon-error-2"></use>
        </svg>${text}
      </p>
    `;
  }
}
